module.exports = __webpack_public_path__ + "img/18.8e22b43a.jpg";